import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Label from './Label';
import BorderRandomizer from './BorderRandomizer';
import { borderTitle } from '../icons/borders';

import * as AppPropTypes from '../../lib/PropTypes';

import styles from '../../../styles/partials/title.scss';

const propTypes = {
    seed: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    text: PropTypes.oneOfType([PropTypes.string, AppPropTypes.message]),
    format: PropTypes.string,
    borders: PropTypes.object, // eslint-disable-line
    borderPosition: PropTypes.string,
    borderClassName: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    seed: '',
    text: null,
    format: null,
    borders: borderTitle,
    borderPosition: null,
    borderClassName: null,
    className: null,
};

const Title = ({ seed, text, format, borders, borderPosition, borderClassName, className }) => {
    if (text === null) {
        return null;
    }
    const titleSeed = useMemo(() => {
        return Math.random() * 1000 + seed;
    }, [seed]);
    return (
        <div
            className={classNames([
                styles.container,
                {
                    [styles[format]]: format !== null,
                    [className]: className !== null,
                },
            ])}
        >
            {borderPosition === 'top' ? (
                <BorderRandomizer
                    seed={titleSeed}
                    borders={borders}
                    borderClassName={borderClassName}
                    className={styles.borderRandomizer}
                />
            ) : null}
            {(() => {
                switch (format) {
                    case 'large':
                        return (
                            <h1>
                                <Label>{text}</Label>
                            </h1>
                        );
                    case 'normal':
                        return (
                            <h2>
                                <Label>{text}</Label>
                            </h2>
                        );

                    default:
                        return (
                            <h3>
                                <Label>{text}</Label>
                            </h3>
                        );
                }
            })()}
            {borderPosition === 'bottom' ? (
                <BorderRandomizer
                    seed={titleSeed}
                    borders={borders}
                    borderClassName={borderClassName}
                    className={styles.borderRandomizer}
                />
            ) : null}
        </div>
    );
};

Title.propTypes = propTypes;
Title.defaultProps = defaultProps;

export default Title;
